"use client";

import { ImageOff } from "lucide-react";
import { useState } from "react";

interface ImageProps {
  src: string;
  alt: string;
  className?: string;
  fallback?: React.ReactNode;
}

export function Image({ src, alt, className, fallback = null }: ImageProps) {
  const [hasError, setHasError] = useState(false);

  if (hasError) {
    return (
      fallback || (
        <div className={`flex items-center justify-center ${className || ""} bg-gray-50 p-2`}>
          <ImageOff className="w-[40%] h-[40%] text-gray-500" strokeWidth={1} />
        </div>
      )
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => {
        setHasError(true);
      }}
    />
  );
}
